import React, { useEffect } from 'react'
import AOS from "aos";

const ExpertThought = () => {
    useEffect(() => {
        AOS.init({ duration: 2000, },);
    }, [])
    return (
        <>
            <section className='expert_thought_wrap'>
                <div className='expert_thought_text' data-aos='fade-down'>
                    <h5>What was missing in our previous careers, was that 360-degree wellbeing awareness, support and techniques applied to our day-to-day lives to feel empowered and healthy enough to be able to grow in our careers. This inspired us to build our own wellbeing solution.</h5>
                    <h6>Alexandra Kafka</h6>
                    <p>Founder and Mindfulness Coach</p>
                </div>
            </section>
        </>
    )
}

export default ExpertThought